import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1TextFieldTheme: Components<Theme>['MuiTextField'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            '& .MuiInputBase-root': {
                backgroundColor: 'background.default',
                borderColor: 'divider',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'divider',
            },
            '& .Mui-error.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                borderColor: 'error.main',
            },
            '& .MuiInputBase-multiline .MuiInputBase-input': {
                borderRadius: 0,
            },
        }),
    },
    defaultProps: {
        inputProps: {
            sx: { backgroundColor: 'background.default' },
        },
    },
}
